import React from 'react';
import { EnumCell } from '@monorepo/ui-kit';
import { enumToSelectOptions } from '@monorepo/helpers';
import { useI18n } from '@monorepo/i18n';
import { FAST_DEAL_LOGISTICS } from '../../constants';

type TProps = {
  value: string | number;
  defaultValue: string;
};

const FastDealLogisticsEnum: FC<TProps> = ({ value, defaultValue }) => {
  const { t } = useI18n();
  return (
    <EnumCell
      dictionary={
        enumToSelectOptions(FAST_DEAL_LOGISTICS, false, (item) =>
          t(`logistics.${item}`)
        ) as any
      }
      value={value}
      defaultValue={defaultValue}
    />
  );
};

export default FastDealLogisticsEnum;
